'use client'

import { isbot } from 'isbot'

// Counts the job page view on the server for the System Overview funnel (/api/job-page-view). A crawler hit is not a
// view, as in sendEventToAnalytics.
export default function countJobPageView(): void {
  if (isbot(navigator.userAgent)) {
    return
  }
  // keepalive: the request still completes when the visitor leaves the page at once
  fetch('/api/job-page-view', { cache: 'no-store', keepalive: true }).catch(() => undefined)
}
